import { createSlice } from '@reduxjs/toolkit';

const onboardSlice = createSlice({
  name: 'onboard',
  initialState: {
    currentStep: 0,
    isOnboardingComplete: false, // <-- Add this
  },
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setOnboardingComplete: (state, action) => {
      state.isOnboardingComplete = action.payload;
    },
  },
});

export const { setStep, setOnboardingComplete } = onboardSlice.actions;

export default onboardSlice.reducer;
